<template>
  <component :is="layout">
    <div class="login-form-wrapper">
      <form
          class="login-form"
          :class="{ 'login-form--shake': formIsShaking }"
          @submit.prevent="logInUser">
          <span
              v-if="nonFieldErrors"
              class="help-text error-msg error"
          >
              {{ nonFieldErrors }}
          </span>
          <text-input
              v-model="creds.username"
              inputId="login"
              label="Логин"
              label-alignment="center"
          />
          <text-input
              v-model="creds.password"
              inputId="password"
              label="Пароль"
              label-alignment="center"
              input-type="password"
          />
          <v-button
              class="login-form-submit"
              label="Войти"
          />
          <router-link
                  class="registration-link"
                  :to="{name: 'registration'}">
                  Еще нет аккаунта? Получить доступ.
          </router-link>
<!--          <div class="additional">-->
<!--              <a target="_blank"-->
<!--                 href="http://opendata.university/#contact-us"-->
<!--                 v-tooltip.right="'Для того, чтобы получить доступ к ' +-->
<!--                  'платформе вам нужно заполнить форму и ' +-->
<!--                  'дождаться ответа.'">-->
<!--                  Как получить доступ?</a>-->
<!--          </div>-->
      </form>
      <logos />
    </div>
  </component>
</template>

<script>
import TextInput from '../components/form_components/TextInput'
import vButton from '../components/vButton'
import Logos from "../components/Logos";

export default {
  name: 'Login',
  components: {
    TextInput,
    vButton,
    Logos
  },
  data() {
    return {
      layout: 'simple-layout',
      creds: {
        username: '',
        password: '',
      },
      formIsShaking: false
    }
  },
  methods: {
    async logInUser() {
      if (!this.formIsFilled) {
        this.$store.commit('setErrors', { form: 'login', errors: { nonFieldErrors: ['Поля должны быть заполнены.'] } })
        this.shakeForm()
        return
      }

      await this.$store.dispatch('logIn', this.creds)

      if (this.nonFieldErrors) {
        this.shakeForm()
      } else {
        this.$router.push('/')
      }
    },
    shakeForm() {
      this.formIsShaking = true
      window.setTimeout(() => this.formIsShaking = false, 100)
    }
  },
  computed: {
    nonFieldErrors() {
      return this.$store.getters.errorsPretty.login.nonFieldErrors
    },
    formIsFilled() {
      return !(this.creds.password === '' || this.creds.username === '')
    }
  }
}
</script>

<style scoped lang="sass">
    @import '../assets/sass/animations'

    .registration-link
        color: #5CA5D4
        text-decoration: none
        padding: gridSteps(2)
        &:hover
            text-decoration: underline

    .additional
        margin: gridSteps(1.5)
        a
            color: #5CA5D4
            text-decoration: none
            padding: gridSteps(1)
        a:hover
            text-decoration: underline
            color: #337bd4

    .login-form-wrapper
        position: absolute
        top: 50%
        left: 50%
        transform: translate(-50%, -50%)

    .login-form
        display: flex
        flex-flow: column
        align-items: center

    .login-form--shake
        animation: shake 100ms

    .login-form-submit
        margin-top: gridSteps(1)

    .error-msg
        position: absolute
        top: -1*gridSteps(6)
</style>
